import styled from 'styled-components';

import { EditorType, subScriptClassName, superScriptClassName } from '../../../containers/Editor/constants';
import { NewStyleColor } from '../../../utils/styles-constants';

interface StyledEditorWrapperProps {
	editorType: EditorType;
	isActive: boolean;
	isEmpty: boolean;
	outlineWidth: number;
	shouldShowScrollbar: boolean;
	width?: number;
	height?: number;
	transform?: string;
	isAccessibleVersion?: boolean;
}

const StyledEditorWrapper = styled('div')`
	width: ${({ width }: StyledEditorWrapperProps) => width ? `${width}px` : ''};
	height: ${({ height }: StyledEditorWrapperProps) => height ? `${height}px` : ''};
	transform: ${({ transform }: StyledEditorWrapperProps) => transform ? transform : ''};
	overflow: hidden;
	pointer-events: auto;

	${({ editorType }: StyledEditorWrapperProps) => editorType === EditorType.HTML &&
		'position: relative;'
	}

	${({ editorType, isActive, isEmpty, isAccessibleVersion }: StyledEditorWrapperProps) => editorType === EditorType.INDESIGN && (isActive || isEmpty) && `
		position: ${isAccessibleVersion ? 'relative' : 'absolute'};
		top: 0;
		left: 0;
		z-index: 1;
	`}

	${({ isActive, isEmpty, outlineWidth, editorType }: StyledEditorWrapperProps) => (isActive || isEmpty) &&
		`outline: ${editorType === EditorType.INDESIGN ? outlineWidth : 2}px solid ${isActive ? NewStyleColor.Blue100 : NewStyleColor.Grey400};`
	}

	> div {
		height: 100%;
		-webkit-user-modify: read-write !important; // Fix for Chrome 105+
	}

	${({ editorType }: StyledEditorWrapperProps) => editorType === EditorType.INDESIGN && `
		> div {
			position: relative;
			top: -1px;
		}
	`}

	a {
		color: inherit;
		text-decoration: none;
	}

	ul, ol {
		margin: 0;
		padding-left: 1.5em;
	}

	.${subScriptClassName},
	.${superScriptClassName} {
		position: relative;
		font-size: 75%;
	}

	.${subScriptClassName} {
		top: 0.35em;
	}

	.${superScriptClassName} {
		top: -0.35em;
	}

	${({ shouldShowScrollbar }: StyledEditorWrapperProps) => shouldShowScrollbar && `
		> div {
			/* show scrollbar on editable text fields like in the reader */
			overflow-y: auto;
			overflow-x: hidden;
			padding-right: 4px;

			/* custom scrollbar on firefox */
			scrollbar-width: thin;
			scrollbar-color: ${NewStyleColor.Grey500} ${NewStyleColor.Grey100};

			/* custom scrollbar on chrome */
			&::-webkit-scrollbar {
				width: 3px;
				background-color: ${NewStyleColor.Grey100};
			}

			&::-webkit-scrollbar-track {
				background-color: ${NewStyleColor.Grey100};
				border-radius: 1px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: ${NewStyleColor.Grey500};
				border-radius: 1px;
			}

			.editable-button-link & {
				overflow-y: hidden;
				padding-right: 0;
			}
		}
	`}
`;

export {
	StyledEditorWrapper,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/styles.ts